// extracted by mini-css-extract-plugin
export default {"Overlay":"Modal_Overlay__8r0h5","Modal":"Modal_Modal__rJvAo","closeBtn":"Modal_closeBtn__JO4ed"};